export type MessageKind = "LoadSets" | "LoadCards" | "ProcessStatus" | "Error";

export class BaseWorkerMessage
{
    kind: string;
    constructor() { }
}


// WEBPACK FOOTER //
// ./src/deckard/models/BaseWorkerMessage.ts